import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App.jsx";
import ErrorBoundary from "./Components/ErrorBoundary/index.jsx";
import queryClient from "@Shared/Query/queryClient";
import "./Resources/Sass/main.scss";
import "./Resources/Css/site.css";
import { unregister as unregisterServiceWorker } from "./serviceWorker";

const { PUBLIC_URL } = import.meta.env;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App
        basename={PUBLIC_URL}
      />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </ErrorBoundary>
);

unregisterServiceWorker();
